module.exports = __webpack_public_path__ + "img/icon10.3facef08.png";